import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronWide3OutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="m23.005 19.442-.91 1.554-10.09-5.913-10.09 5.913-.91-1.554 11-6.445z" fill="currentColor" />
            <path d="m23.005 13.442-.91 1.554-10.09-5.913-10.09 5.913-.91-1.554 11-6.445z" fill="currentColor" />
            <path d="m23.005 7.442-.91 1.554-10.09-5.913-10.09 5.913-.91-1.554 11-6.445z" fill="currentColor" />
        </g>
    </svg>
));
ChevronWide3OutlinedSize24Glyph.displayName = 'ChevronWide3OutlinedSize24Glyph';
